import React, {useEffect} from 'react';
import {useSnippetContext} from "../Utils/UseSnippetContext";
import {useAuth} from "../Utils/UseAuth";
import useServiceUrls from "../Utils/UseServiceUrls";
import useStripePaymentForm from "../Utils/UseStripePaymentForm";
import {mapServiceUrls} from "../Helpers/Functions";
import {ISyntheticEvent} from "../Helpers/Types";
import LoadingSpinner from "../LoadingSpinner";

type StripeFormProps = {
    back: Function
    successUrl?: string
    cancelUrl?: string
}

export default function StripeForm(props: StripeFormProps) {
    // @ts-ignore
    const { domain, deviceCode } = useSnippetContext();
    // @ts-ignore
    const { session } = useAuth();
    const { serviceUrls } = useServiceUrls(domain);
    const [getStripePaymentForm, { status, data, error }] = useStripePaymentForm();

    // Stripe uses a hosted checkout page - once the session is created we hand the
    // browser off to the returned url. On completion/cancel Stripe redirects back to
    // the success/cancel urls (the current page by default) and the snippet reloads
    // the customer's payment methods.
    useEffect(() => {
        if (status === 'success' && data?.data?.Url)
            window.location.href = data.data.Url
    }, [status, data])

    const continueToStripe = (e: ISyntheticEvent) => {
        e.preventDefault()
        getStripePaymentForm({
            urls: mapServiceUrls(serviceUrls),
            session,
            domain,
            deviceCode,
            successUrl: props.successUrl ?? window.location.href,
            cancelUrl: props.cancelUrl ?? window.location.href,
        })
    }

    const redirecting = status === 'loading' || status === 'success'

    return (
        <div className='bLoyal-center'>
            <p>You'll be redirected to Stripe to securely enter your payment details.</p>
            <button className='bl-snippet-button' id='continue-to-stripe' onClick={continueToStripe} disabled={redirecting}>Continue to Stripe</button>
            <button className='bl-snippet-button' onClick={() => props.back()} disabled={redirecting}>Back</button>
            {redirecting && <LoadingSpinner />}
            {status === 'error' && <p className='bLoyal-error-text'>Unable to start Stripe checkout. Please try again.</p>}
        </div>
    )
}
